/* Delune on phones: the small behaviours that go with assets/delune-mobile.css (mobile audit, 1 Oct 2026). */
(function () {
  'use strict';

  var hasPubSub = typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined';

  /* Bag: open on the tap with a placeholder row, instead of a second after it when the add request returns */
  function bagOnTap() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var timer;

    var done = function (close) {
      clearTimeout(timer);
      if (!drawer.classList.contains('dm-adding')) return;
      drawer.classList.remove('dm-adding');
      if (close && typeof drawer.close === 'function') drawer.close();
    };

    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
        if (form.closest('quick-add-modal') || form.closest('cart-drawer')) return;
        var button = form.querySelector('[type="submit"]');
        var id = form.querySelector('[name="id"]');
        if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
        if (!id || id.disabled) return;

        drawer.classList.add('dm-adding');
        if (typeof drawer.open === 'function') drawer.open();
        clearTimeout(timer);
        timer = setTimeout(function () {
          done(true);
        }, 10000);
      },
      true
    );

    if (hasPubSub) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(function () {
          done(false);
        }, 0);
      });
      subscribe(PUB_SUB_EVENTS.cartError, function () {
        done(true);
      });
    }
  }

  /* Bag: "Pairs well with" rows, fetched once the bag is open and kept out of the bag's own render */
  function bagRecommendations() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var cache = {};

    var show = function (slot, pages) {
      if (!slot.isConnected) return;
      var inBag = (slot.dataset.inBag || '').split(',');
      var gap = parseInt(slot.dataset.gap, 10) || 0;
      var inner = null;
      var rows = [];
      var seen = {};
      // Hand-picked pairings first, then Shopify's related products; nothing twice, nothing already in the bag
      pages.forEach(function (html) {
        var found = html && new DOMParser().parseFromString(html, 'text/html').querySelector('.delune-cart__recs-inner');
        if (!found) return;
        inner = inner || found;
        found.querySelectorAll('.delune-cart__rec').forEach(function (row) {
          var id = row.dataset.productId;
          if (seen[id] || inBag.indexOf(id) > -1) return;
          seen[id] = true;
          rows.push(row);
        });
      });
      if (!inner || !rows.length) return;
      // Short of free delivery: a product that needs no choice and closes the gap goes first, cheapest first
      if (gap > 0) {
        var closes = function (row) {
          return row.hasAttribute('data-single') && parseInt(row.dataset.price, 10) >= gap;
        };
        var unlock = rows.filter(closes).sort(function (a, b) {
          return parseInt(a.dataset.price, 10) - parseInt(b.dataset.price, 10);
        });
        rows = unlock.concat(
          rows.filter(function (row) {
            return !closes(row);
          })
        );
      }
      var list = inner.querySelector('.delune-cart__recs-list');
      list.textContent = '';
      rows.slice(0, 2).forEach(function (row) {
        // The thumbnails come lazy-loaded from the fetched page; in a drawer that just opened they would stay blank
        row.querySelectorAll('img').forEach(function (img) {
          img.loading = 'eager';
        });
        list.appendChild(row);
      });
      slot.textContent = '';
      slot.appendChild(document.importNode(inner, true));
      slot.hidden = false;
    };

    var fill = function () {
      // Not while the bag is still showing its placeholder: the items in it are about to be replaced
      if (!drawer.classList.contains('active') || drawer.classList.contains('dm-adding')) return;
      // One slot per drawing of the bag: once a row is in, the list is shorter and would measure differently
      if (drawer.querySelector('.delune-cart__recs[data-filled]')) return;
      // The row is pinned above the totals when that still leaves room for an item and a half in the list;
      // otherwise it goes at the end of the item list. Measured, not guessed from the screen size, because
      // phone browsers report a shorter window while their toolbars are showing.
      // On desktop it always goes in the list, as two small cards (assets/delune-desktop.css).
      var items = drawer.querySelector('cart-drawer-items');
      var wanted = window.innerWidth < 750 && items && items.offsetHeight - 125 >= 170 ? 'pinned' : 'list';
      var slot =
        drawer.querySelector('.delune-cart__recs[data-slot="' + wanted + '"]') || drawer.querySelector('.delune-cart__recs');
      var id = slot && slot.dataset.productId;
      if (!id || slot.dataset.filled) return;
      slot.dataset.filled = 'true';
      if (!cache[id]) {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var url = root + 'recommendations/products?product_id=' + id + '&limit=10&section_id=delune-bag-recommendations';
        var get = function (address) {
          return fetch(address)
            .then(function (response) {
              return response.ok ? response.text() : '';
            })
            .catch(function () {
              return '';
            });
        };
        cache[id] = Promise.all([get(url + '&intent=complementary'), get(url)]);
      }
      cache[id].then(function (pages) {
        show(slot, pages);
      });
    };

    new MutationObserver(fill).observe(drawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    fill();
  }

  /* Sticky buy bar: on screen whenever the page's own Add to bag is not, including at page load, but never while
     the shade or size picker is on screen: the bar would sit over the choice and add an option nobody picked. */
  function stickyFromLoad() {
    var bar = document.querySelector('sticky-atc');
    if (!bar) return;
    var buttonSelector = 'product-form:not(.sticky-atc__form-wrap) [type="submit"][name="add"]';
    if (!document.querySelector(buttonSelector)) return;

    var onScreen = function (element) {
      if (!element) return false;
      var box = element.getBoundingClientRect();
      if (!box.width && !box.height) return false;
      return box.bottom > 0 && box.top < window.innerHeight;
    };

    var update = function () {
      var button = document.querySelector(buttonSelector);
      var picker = document.querySelector('product-info variant-selects');
      // Phones (13 Oct 2026): the bar shows whenever Add to bag is off screen, picker or not, since it now carries
      // the chosen shade and the price. Desktop keeps stepping aside for the picker.
      var phone = window.matchMedia('(max-width: 749px)').matches;
      bar.classList.toggle('dm-show', !onScreen(button) && (phone || !onScreen(picker)));
    };

    var queued = false;
    var queue = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        update();
      });
    };

    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue, { passive: true });
    window.addEventListener('load', update);
    if (hasPubSub) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(update, 300);
      });
    }
    update();
  }

  /* Product gallery on phones: a row of dots under the photo, one per picture, the current one filled; a tap on a
     dot slides to that picture. Rebuilt when the theme swaps the gallery for another shade. (13 Oct 2026, in place
     of the progress line.) */
  /* Phone-only first photo (custom.mobile_main_image, 27 Oct 2026, reworked 29 Oct): keep the .dm-mobile-main slide first
     and hide the selected variant's own featured photo. The theme swaps slides on variant change and then prepends the
     variant's featured photo, and delune-shade-gallery.js prepends the shade's photos at 0/60/400 ms, so a MutationObserver
     on the list re-applies after any reorder. The slide to hide comes from data-dm-hide (server-rendered) and is refreshed
     from the variantChange event, because a product-level phone slide keeps its element across variants. */
  function mobileMain() {
    var getList = function () {
      return document.querySelector('product-info .product__media-wrapper .product__media-list');
    };
    var applying = false;
    var apply = function () {
      var list = getList();
      if (!list || applying) return;
      applying = true;
      try {
        var mobile = list.querySelector('.dm-mobile-main');
        Array.prototype.forEach.call(list.querySelectorAll('.dm-hidden'), function (slide) {
          if (!mobile || slide.dataset.mediaId !== mobile.getAttribute('data-dm-hide')) slide.classList.remove('dm-hidden');
        });
        if (!mobile) return;
        if (list.firstElementChild !== mobile) list.prepend(mobile);
        var hide = mobile.getAttribute('data-dm-hide');
        var target = hide && list.querySelector('[data-media-id="' + hide + '"]');
        if (target && target !== mobile) target.classList.add('dm-hidden');
        if (window.innerWidth < 750 && list.scrollLeft !== 0) list.scrollTo({ left: 0 });
      } finally {
        applying = false;
      }
    };
    apply();
    var list = getList();
    if (list && typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        var mobile = list.querySelector('.dm-mobile-main');
        if (!mobile) return;
        var hide = mobile.getAttribute('data-dm-hide');
        var target = hide && list.querySelector('[data-media-id="' + hide + '"]');
        if (list.firstElementChild !== mobile || (target && !target.classList.contains('dm-hidden'))) apply();
      }).observe(list, { childList: true });
    }
    if (hasPubSub) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        var current = getList();
        var mobile = current && current.querySelector('.dm-mobile-main');
        if (mobile && variant && variant.featured_media && variant.featured_media.id && event.data.sectionId) {
          mobile.setAttribute('data-dm-hide', event.data.sectionId + '-' + variant.featured_media.id);
        }
        [0, 100, 500].forEach(function (delay) {
          setTimeout(apply, delay);
        });
      });
    }
  }

  function galleryDots() {
    var selector = 'product-info .product__media-wrapper .product__media-list';

    // Only the pictures on show: the per-shade gallery hides the other shades' photos (delune-shade-hidden)
    var shown = function (list) {
      return Array.prototype.filter.call(list.querySelectorAll('.product__media-item'), function (slide) {
        return slide.offsetWidth > 0;
      });
    };

    var build = function () {
      var list = document.querySelector(selector);
      var slider = list && list.closest('slider-component');
      if (!slider) return null;
      var slides = shown(list);
      var dots = slider.querySelector('.dm-dots');
      if (slides.length < 2) {
        if (dots) dots.remove();
        slider.classList.remove('dm-has-dots');
        return null;
      }
      if (dots && dots.childElementCount === slides.length) return dots;
      if (!dots) {
        dots = document.createElement('div');
        dots.className = 'dm-dots';
        dots.setAttribute('aria-label', 'Product photos');
        slider.appendChild(dots);
      }
      dots.innerHTML = '';
      slides.forEach(function (slide, index) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'dm-dot';
        dot.setAttribute('aria-label', 'Photo ' + (index + 1) + ' of ' + slides.length);
        dot.addEventListener('click', function () {
          var target = shown(list)[index];
          if (target) list.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        });
        dots.appendChild(dot);
      });
      slider.classList.add('dm-has-dots');
      return dots;
    };

    var update = function () {
      var dots = build();
      if (!dots) return;
      var list = document.querySelector(selector);
      var slides = shown(list);
      var index = 0;
      var nearest = Infinity;
      slides.forEach(function (slide, i) {
        var distance = Math.abs(slide.offsetLeft - list.scrollLeft);
        if (distance < nearest) {
          nearest = distance;
          index = i;
        }
      });
      Array.prototype.forEach.call(dots.children, function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    };

    var queued = false;
    var queue = function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        update();
      });
    };

    document.addEventListener(
      'scroll',
      function (event) {
        if (event.target && event.target.classList && event.target.classList.contains('product__media-list')) queue();
      },
      true
    );
    window.addEventListener('resize', queue, { passive: true });
    if (hasPubSub) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(update, 150);
        setTimeout(update, 600);
      });
    }
    update();
  }

  /* Product page on phones: the stars line reads "4.9 · 68 reviews" instead of "(4.9) Based on 68 reviews" (CSS clips
     the five stars to one). The reviews app can redraw the badge, so the words are checked again on every change. */
  function compactStars() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var info = document.querySelector('.product__info-container');
    if (!info) return;

    var rewrite = function () {
      info.querySelectorAll('.rapid_reviews_stars_badge .r_count').forEach(function (count) {
        if (count.dataset.dmCompact === '1') return;
        var avg = count.querySelector('.dl-rating-avg');
        var rest = Array.prototype.filter.call(count.childNodes, function (n) { return n.nodeType === 3; }).map(function (n) { return n.textContent; }).join(' ');
        var m = rest.match(/(\d+)\s+(reviews?)/i);
        if (!avg || !m) return;
        avg.textContent = avg.textContent.replace(/[()]/g, '').trim();
        Array.prototype.forEach.call(count.childNodes, function (n) { if (n.nodeType === 3) n.textContent = ''; });
        count.appendChild(document.createTextNode('· ' + m[1] + ' ' + m[2].toLowerCase()));
        count.dataset.dmCompact = '1';
      });
    };

    new MutationObserver(rewrite).observe(info, { childList: true, subtree: true });
    rewrite();
  }

  /* Product page on phones: size / strength pickers (pill buttons, not the shade swatches, which carry their own
     "Shade: …" legend) get a "Selected: 10ml" line under the pills so the choice is confirmed before Add to bag.
     The theme redraws the picker on every variant change, so the line is rebuilt when that happens. */
  function selectedLine() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var root = document.querySelector('.product__info-container');
    if (!root) return;

    var render = function () {
      root.querySelectorAll('.product-form__input--pill').forEach(function (field) {
        if (field.classList.contains('dm-swatches') || field.querySelector('label.dm-swatch')) return;
        var checked = field.querySelector('input[type="radio"]:checked');
        if (!checked) return;
        // The pill's own words (the size or strength), not the price or per-ml spans inside the label, and not the
        // input value, which is just "on" on the custom strength picker
        var label = (checked.id && field.querySelector('label[for="' + checked.id + '"]')) || checked.closest('label');
        if (!label && checked.nextElementSibling && checked.nextElementSibling.tagName === 'LABEL') label = checked.nextElementSibling;
        var value = '';
        if (label) {
          // The words are direct text of the label (Dawn pills) or of its first child (the strength pills, where the
          // label wraps a link or span); never the price or per-ml spans
          var holder = label;
          var own = Array.prototype.filter.call(holder.childNodes, function (n) { return n.nodeType === 3 && n.textContent.trim(); });
          if (!own.length && holder.firstElementChild) holder = holder.firstElementChild;
          value = Array.prototype.filter.call(holder.childNodes, function (n) { return n.nodeType === 3; }).map(function (n) { return n.textContent; }).join(' ').replace(/\s+/g, ' ').trim();
        }
        if (!value) value = (checked.value && checked.value !== 'on') ? checked.value : (label ? label.textContent.trim().split('\n')[0].trim() : '');
        if (!value) return;
        var line = field.nextElementSibling && field.nextElementSibling.classList.contains('dm-selected') ? field.nextElementSibling : null;
        if (!line) {
          line = document.createElement('p');
          line.className = 'dm-selected';
          line.innerHTML = 'Selected: <span data-dm-selected></span>';
          field.insertAdjacentElement('afterend', line);
        }
        var out = line.querySelector('[data-dm-selected]');
        if (out.textContent !== value) out.textContent = value;
      });
    };

    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest && event.target.closest('.product-form__input--pill')) setTimeout(render, 50);
    });
    new MutationObserver(render).observe(root, { childList: true, subtree: true });
    if (hasPubSub) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        setTimeout(render, 150);
        setTimeout(render, 600);
      });
    }
    render();
  }

  /* Mobile pass 13 Oct 2026 — 1: tapping the stars opens the Reviews accordion (the reviews are folded into the app
     accordion and are not on the page until it opens) and scrolls to it. 2: "Learn more" on the instalments line opens
     the Tabby plan popup in place instead of leaving the page. */
  function starsAndLearnMore() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var stars = target.closest('.product__info-container .rapid_reviews_stars_badge a');
      if (stars) {
        var box = document.querySelector('details[id*="rapid_reviews_reviews"]');
        if (!box) return;
        event.preventDefault();
        box.open = true;
        // The reviews are injected after the box opens and the page grows, so the scroll is taken twice
        var jump = function () {
          window.scrollTo(0, box.getBoundingClientRect().top + window.scrollY - 70);
        };
        setTimeout(jump, 250);
        setTimeout(jump, 1000);
        return;
      }
      var learn = target.closest('.product__info-container .delune-bnpl__link');
      if (learn) {
        var tabby = document.querySelector('.delune-bnpl__logo[data-bnpl="tabby"]');
        if (!tabby) return;
        event.preventDefault();
        tabby.click();
      }
    });
  }

  /* 5: the description is clamped to three lines with a "Read more" toggle when it runs longer than that */
  function clampDescription() {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var body = document.querySelector('.delune-desc__body');
    if (!body || body.dataset.dmClamp) return;
    body.dataset.dmClamp = '1';
    var lineHeight = parseFloat(getComputedStyle(body).lineHeight) || 24;
    if (body.getBoundingClientRect().height <= lineHeight * 4) return;
    body.classList.add('dm-clamped');
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'dm-readmore';
    button.textContent = 'Read more';
    button.setAttribute('aria-expanded', 'false');
    button.addEventListener('click', function () {
      var open = body.classList.toggle('dm-clamped') === false;
      button.textContent = open ? 'Read less' : 'Read more';
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    body.insertAdjacentElement('afterend', button);
  }

  /* Instalments: say the amount ("4 interest-free payments of AED 44.75 with"), and keep it in step with the size */
  function instalmentAmount() {
    var label = document.querySelector('.delune-bnpl .delune-bnpl__label');
    var info = document.querySelector('.product__info-container');
    if (!label || !info) return;
    var fallback = label.textContent;

    var render = function () {
      var price = info.querySelector('.price');
      var item =
        price &&
        (price.classList.contains('price--on-sale')
          ? price.querySelector('.price-item--sale')
          : price.querySelector('.price__regular .price-item--regular'));
      var match = item && item.textContent.replace(/,/g, '').match(/^\s*([^\d]*)(\d+(?:\.\d+)?)/);
      var text = fallback;
      if (match && parseFloat(match[2]) > 0) {
        var each = (parseFloat(match[2]) / 4).toFixed(2).replace(/\.00$/, '');
        // Phones (owner, 13 Oct 2026): the short form "4 × AED 44.75 with", so logos and Learn more fit on one line
        var phone = window.matchMedia('(max-width: 749px)').matches;
        text = (phone ? '4 × ' : '4 interest-free payments of ') + match[1].trim() + ' ' + each + ' with';
      }
      if (label.textContent !== text) label.textContent = text;
    };

    new MutationObserver(render).observe(info, { childList: true, subtree: true, characterData: true });
    render();
  }

  /* Drawers: a sideways swipe closes the bag (right) and the menu (left); a downward swipe closes the filter sheet */
  function swipeToClose() {
    var start = null;

    document.addEventListener(
      'touchstart',
      function (event) {
        start = null;
        var target = event.target;
        if (!target || !target.closest || event.touches.length !== 1) return;
        if (target.closest('.delune-drawer__rail, .delune-cart__recs-list, .slider, input, select, textarea')) return;
        var panel = target.closest('cart-drawer .drawer__inner, #menu-drawer, .mobile-facets__inner');
        if (!panel) return;
        start = {
          x: event.touches[0].clientX,
          y: event.touches[0].clientY,
          time: Date.now(),
          panel: panel,
          atTop: panel.scrollTop <= 0 && !(target.closest('.mobile-facets__main') || {}).scrollTop,
        };
      },
      { passive: true }
    );

    document.addEventListener(
      'touchend',
      function (event) {
        var from = start;
        start = null;
        if (!from || Date.now() - from.time > 600) return;
        var touch = event.changedTouches[0];
        var dx = touch.clientX - from.x;
        var dy = touch.clientY - from.y;

        if (from.panel.classList.contains('mobile-facets__inner')) {
          // Only from the top of the sheet, so scrolling its contents never closes it
          if (!from.atTop || dy < 70 || dy < Math.abs(dx) * 2) return;
          var filters = from.panel.closest('details');
          var toggle = filters && filters.querySelector('summary');
          if (toggle) toggle.click();
          return;
        }

        if (Math.abs(dx) < 70 || Math.abs(dx) < Math.abs(dy) * 2) return;
        if (from.panel.id === 'menu-drawer') {
          var summary = document.querySelector('header-drawer > details > summary');
          if (dx < 0 && summary) summary.click();
        } else if (dx > 0) {
          var drawer = from.panel.closest('cart-drawer');
          if (drawer && typeof drawer.close === 'function') drawer.close();
        }
      },
      { passive: true }
    );
  }

  /* Collections: the filter panel (a sheet from the bottom on phones, a panel from the right on wider screens).
     1. Opening or closing it must not jump the page to the top. The theme focuses the button's <summary>, which
        sits at the top of the grid; this keeps that focus from scrolling.
     2. The theme closes every filter group when the panel closes; the panel shows them all as chips, so they are
        opened again each time it opens.
     3. Sort by is a menu on phones and a list of choices on wider screens (snippets/facets.liquid prints both).
        Only the one on show is live, so the form sends one answer. The theme redraws the panel after every
        change, so this is put right again each time. */
  function filterSheet() {
    var wide = window.matchMedia('(min-width: 750px)');
    var form = document.getElementById('FacetFiltersFormMobile');
    if (form) {
      var oneSort = function () {
        form.querySelectorAll('.mobile-facets__sort').forEach(function (sort) {
          var menu = sort.querySelector('select');
          if (menu) menu.disabled = wide.matches;
          sort.querySelectorAll('input[type="radio"]').forEach(function (choice) {
            choice.disabled = !wide.matches;
          });
        });
      };
      new MutationObserver(oneSort).observe(form, { childList: true, subtree: true });
      if (wide.addEventListener) wide.addEventListener('change', oneSort);
      oneSort();
    }

    document.addEventListener(
      'click',
      function (event) {
        var summary = event.target && event.target.closest && event.target.closest('.mobile-facets__open-wrapper');
        if (!summary) return;
        if (!summary.dmKeepsPlace) {
          summary.dmKeepsPlace = true;
          summary.focus = function (options) {
            HTMLElement.prototype.focus.call(this, Object.assign({}, options, { preventScroll: true }));
          };
        }
        var disclosure = summary.parentElement;
        if (disclosure && !disclosure.open) {
          disclosure.querySelectorAll('.mobile-facets__details').forEach(function (group) {
            group.open = true;
            // The group names are headings here, not rows to open, so the keyboard skips them
            var heading = group.querySelector(':scope > summary');
            if (heading) heading.setAttribute('tabindex', '-1');
          });
        }
      },
      true
    );

    // The theme redraws the groups after each filter change, so the headings can take focus again;
    // Enter or Space on one must still not fold its chips away
    document.addEventListener(
      'keydown',
      function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        var heading = event.target && event.target.matches && event.target.matches('.mobile-facets__details > summary');
        if (heading) event.preventDefault();
      },
      true
    );
  }

  /* Reviews: the widget loads late and always prints a "Questions (0)" tab; hide it while there are none
     (the page already has its own Q&A). A tab with questions in it is left alone. */
  function hideEmptyQuestionsTab() {
    var tries = 0;
    var run = function () {
      var found = false;
      document.querySelectorAll('.r_tabs .r_tab').forEach(function (tab) {
        if (/^Questions \(0\)$/.test(tab.textContent.trim())) {
          tab.style.display = 'none';
          found = true;
        }
      });
      tries += 1;
      if (!found && tries < 20) setTimeout(run, 1000);
    };
    if (document.querySelector('.rapid_reviews_stars_badge, [id*="rapid_reviews"]')) run();
  }

  /* Accordions: the panel unfolds and folds over 0.3s instead of snapping (product details, FAQ) */
  function accordionUnfold() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('animate' in Element.prototype)) return;
    var selector = '.accordion details > summary, .product__accordion details > summary, details.amazon-qa__item > summary';

    document.addEventListener('click', function (event) {
      var summary = event.target && event.target.closest && event.target.closest(selector);
      if (!summary) return;
      var details = summary.parentElement;
      var panel = summary.nextElementSibling;
      if (!panel) return;
      event.preventDefault();
      if (details.dmAnimating) return;

      var opening = !details.open;
      if (opening) details.open = true;
      var style = getComputedStyle(panel);
      var open = { height: style.height, paddingTop: style.paddingTop, paddingBottom: style.paddingBottom, opacity: 1 };
      var shut = { height: '0px', paddingTop: '0px', paddingBottom: '0px', opacity: 0 };

      details.dmAnimating = true;
      panel.style.overflow = 'hidden';
      var animation = panel.animate(opening ? [shut, open] : [open, shut], { duration: 300, easing: 'ease-out' });
      var finish = function () {
        if (!details.dmAnimating) return;
        panel.style.overflow = '';
        if (!opening) details.open = false;
        details.dmAnimating = false;
      };
      animation.onfinish = finish;
      animation.oncancel = finish;
      // In case the browser never reports the end of the animation (a tab in the background, say)
      setTimeout(finish, 450);
    });
  }

  /* Collections: the Sort by menu is as wide as the option showing, so its caret sits next to the word
     (a plain <select> is as wide as its longest option). Browsers that can do this in CSS already have. */
  function fitSortMenu() {
    if (window.CSS && CSS.supports && CSS.supports('field-sizing', 'content')) return;
    var ruler;

    var fit = function (select) {
      var option = select.options[select.selectedIndex];
      if (!option) return;
      var style = getComputedStyle(select);
      if (!ruler) {
        ruler = document.createElement('span');
        ruler.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;left:-999rem;top:0';
        document.body.appendChild(ruler);
      }
      ruler.style.font = style.font;
      ruler.style.letterSpacing = style.letterSpacing;
      ruler.textContent = option.textContent.trim();
      var extra = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
      select.style.width = Math.ceil(ruler.getBoundingClientRect().width + extra + 2) + 'px';
    };

    var all = function () {
      document.querySelectorAll('.facets-wrapper .facet-filters.sorting .facet-filters__sort').forEach(fit);
    };

    document.addEventListener('change', function (event) {
      if (event.target && event.target.matches && event.target.matches('.facet-filters__sort')) fit(event.target);
    });
    window.addEventListener('load', all);
    all();
  }

  /* Product cards: photos shot on plain white are marked, so they can sit on a cream tile instead of a white
     box (assets/delune-polish.css). A photo counts when all four corners are white or see-through;
     photographs that fill the frame are left alone. */
  function cutoutPhotos() {
    var canvas = document.createElement('canvas');
    canvas.width = canvas.height = 12;
    var context = canvas.getContext('2d', { willReadFrequently: true });
    if (!context) return;
    var photos = '.spc-card__image, .card__media img, .dbs-media img';

    var check = function (photo) {
      if (photo.dataset.dmCutout || !photo.naturalWidth) return;
      var plain = false;
      try {
        context.clearRect(0, 0, 12, 12);
        context.drawImage(photo, 0, 0, 12, 12);
        var pixels = context.getImageData(0, 0, 12, 12).data;
        plain = [0, 11, 132, 143].every(function (corner) {
          var i = corner * 4;
          return pixels[i + 3] < 10 || (pixels[i + 3] > 250 && pixels[i] > 246 && pixels[i + 1] > 246 && pixels[i + 2] > 246);
        });
      } catch (error) {
        /* A photo served from another address cannot be read; it keeps its white box */
      }
      photo.dataset.dmCutout = plain ? '1' : '0';
      if (!plain) return;
      photo.classList.add('dm-cutout');
      if (photo.parentElement) photo.parentElement.classList.add('dm-cutout-tile');
    };

    /* load does not bubble, so it is caught on the way down: this also covers cards added later
       (filters, Load more, recommendations) */
    document.addEventListener(
      'load',
      function (event) {
        var photo = event.target;
        if (photo && photo.matches && photo.matches(photos)) check(photo);
      },
      true
    );
    document.querySelectorAll(photos).forEach(function (photo) {
      if (photo.complete) check(photo);
    });
  }

  /* Product pages: "Back" over the photos (snippets/delune-back-button.liquid). Its link goes to the product's
     collection. When the shopper came from a page on this site that is not another product (a collection, a
     search, the home page), it steps back instead, so they return to the spot and the filters they left. */
  function backButton() {
    var link = document.querySelector('[data-delune-back]');
    if (!link || window.history.length < 2) return;
    var from = '';
    try {
      var referrer = new URL(document.referrer);
      if (referrer.origin === window.location.origin) from = referrer.pathname;
    } catch (error) {
      return;
    }
    if (!from || from.indexOf('/products/') > -1) return;
    link.addEventListener('click', function (event) {
      if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      window.history.back();
    });
  }

  var start = function () {
    [bagOnTap, bagRecommendations, stickyFromLoad, mobileMain, galleryDots, compactStars, selectedLine, starsAndLearnMore, clampDescription, instalmentAmount, swipeToClose, filterSheet, hideEmptyQuestionsTab, accordionUnfold, fitSortMenu, cutoutPhotos, backButton].forEach(function (task) {
      try {
        task();
      } catch (error) {
        console.error(error);
      }
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
